<ms-nav-tree [tree]="tree" (toggle)="toggleItem($event)" (selectEvent)="select($event)" (toggleMarkets)="onToggleMarkets()" />
@if (sport) {
    <ms-competition-tree [sport]="sport" [tournaments]="tournaments" [stateless]="true" />
}
